import React, { Component } from 'react';
import '../../../assets/scss/login.scss';

class PublicLayout extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <>{this.props.children}</>;
	}
}

export default PublicLayout;
